import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuth = localStorage.getItem("j-token");
  return isAuth ? children : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
